// extracted by mini-css-extract-plugin
export default {"color-swatches":"color-swatches--mS1lD"};